export default __webpack_public_path__ + "static/media/Snd_TryI.79b4c4ad.mp3";